import businessClient from 'src/services/clients/business'
import { IMeta, IModifier, IModifierEntityUpsertArgs } from 'src/common/interfaces/index.js'

const IModifierListResponse = { meta: IMeta, data: { list: [IModifier] } }

export const inventoryModifier = {
  /**
   * @param {id: number} filter
   * @return {Promise<IModifierListResponse>}
   */
  list(filter, signal) {
    return businessClient().post('inventory/modifier/portal/list', { filter }, { signal })
  },

  /**
   * @param {IModifierEntityUpsertArgs} data
   * @return {Promise<IModifierListResponse>}
   */
  upsert(data, signal) {
    return businessClient().post('inventory/modifier/upsert', { data }, { signal })
  },

  /**
   * @param {id: number} filter
   * @return {Promise<IModifierListResponse>}
   */
  archive(filter, signal) {
    return businessClient().post('inventory/modifier/archive', { filter }, { signal })
  },

  /**
   * @param {data}
   * @return {Promise<IModifierListResponse>}
   */
  bulkUpsert(data, signal) {
    return businessClient().post('inventory/modifier/bulk/update', { data }, { signal })
  },

  /**
   * @param {{from: number; to: number;}} filter
   */
  updateOrd(filter, signal) {
    return businessClient().post('inventory/modifier/update-ord', { filter }, { signal })
  },
}
